import React, { Component } from 'react';
import { DataMonCompte } from '../../data/DataMonCompte';
import { Immocom } from '../../specifique/immocom';
import { EUIPage } from '../EUI/EUIPage';

export class Alarme extends Component {

    constructor(props) {
        super(props);
        this.state = {
            peutGererAlarmesCapsuleClient: false,
            peutGererAlarmesSouhait: false
        }
    }

    _chargementDroitsLiesAuxAlarmes = () => {
        let chargementDroitsLiesAuxAlarmes = DataMonCompte._chargementDroitsLiesAuxAlarmes();
        chargementDroitsLiesAuxAlarmes
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const droits = responseFetch.reponseAPIobjet;
                    const peutGererAlarmesCapsuleClient = droits.peutGererAlarmesCapsuleClient;
                    const peutGererAlarmesSouhait = droits.peutGererAlarmesSouhait;
                    this.setState(
                        {
                            peutGererAlarmesCapsuleClient,
                            peutGererAlarmesSouhait,
                        }
                    );
                }
                else {
                    const stateTemp = {
                        peutGererAlarmesCapsuleClient: false,
                        peutGererAlarmesSouhait: false
                    };
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _getOnglets = () => {
        const { peutGererAlarmesCapsuleClient, peutGererAlarmesSouhait } = this.state;
        let onglets = [];
        if (peutGererAlarmesCapsuleClient && peutGererAlarmesSouhait) onglets.push({ url: "/GestionDesAlarmes", titre: "Gestion des alarmes" });
        if (peutGererAlarmesSouhait) onglets.push({ url: "/Souhaits", titre: "Alarmes liées à un souhait" });
        if (peutGererAlarmesCapsuleClient) onglets.push({ url: "/Capsules", titre: "Alarmes liées à un espace client" }); //2378
        return onglets;
    };

    componentDidMount = () => {
        this._chargementDroitsLiesAuxAlarmes();
    };

    render = () => <EUIPage
        baseUrl="/Alarmes"
        onglets={this._getOnglets()}
    />;

}